import { TranslationService } from "../../../../services/TranslationService";
import { ActivityItemShell } from "../activityManager/shell/ActivityItemShell";
import { ActivityShellAction } from "../activityManager/shell/ActivityShellTypes";
import { ActivityListResponse } from "../entities/AcitivityListResponse";
import { openWhatsappPanel } from "../../../../components/whatsapp/utils/openWhatsappPanel";
import { SafeHtml } from "../../../../components/SafeHtml";
import { usePinActivityHook } from "../hooks/pinActivityHook";
import {
  formatDateDigits,
  formatDateTimeDigits
} from "../../../../utils/FormatUtils";
import { restTimezone } from "../../../../utils/ParseUtils";
import { addIf, isNullOrWhitespace } from "../../../../utils/Utils";
import iconWhatsapp from "../../../../assets/img/ico-whatsapp.png";
import { SanitizeUtils } from "../../../../utils/SanitizeUtils";

const DisplayActivityName = (
  data: { ActivityType?: { ActivityTypeName: string } } | object
) => {
  if (
    "ActivityType" in data &&
    data.ActivityType?.ActivityTypeName !== undefined
  ) {
    return <> - {data.ActivityType.ActivityTypeName}</>;
  }
  return <></>;
};

export const ActivityWhatsapp = ({
  data,
  reload
}: {
  data: ActivityListResponse.Item;
  reload: () => void;
}) => {
  const { translate } = TranslationService;
  const { icon, canPin, togglePinActivity, tooltip } = usePinActivityHook({
    data,
    reload
  });

  const onReadMoreClicked = async () => {
    await openWhatsappPanel({
      personId: String(data.PersonId),
      isNewConversation: !data.Chat,
      historyMessageId: data.ID,
      onSubmit: reload
    });
  };

  const actions: ActivityShellAction[] = [
    ...addIf(canPin, { icon, onClick: togglePinActivity, tooltip })
  ];

  const date = new Date(data.date);
  const creator = isNullOrWhitespace(data.From)
    ? isNullOrWhitespace(data.Username)
      ? isNullOrWhitespace(data.CreatorUsername)
        ? data.CollectorName
        : data.CreatorUsername
      : data.Username
    : data.From;

  const iconNode = (
    <img className="img-fluid" src={iconWhatsapp} alt="icon whatsapp" />
  );

  const headerNode = (
    <div className="type">
      {data.typeName && <>{TranslationService.getTranslation(data.typeName)}</>}
      <span className="creator">
        {" "}
        {translate.From.toLowerCase()}{" "}
        {data.ChatStatus && data.ChatStatus > 0
          ? "Chatbot Whatsapp"
          : (creator ?? "").split(", ").reverse().join(" ")}
        {DisplayActivityName(data)}
        {data.To && (
          <>
            {" "}
            | {translate.To}: {data.To}
          </>
        )}
      </span>
    </div>
  );

  const contentNode = (
    <div>
      {data.Subject && (
        <small>
          <em>
            <strong>
              {translate.Subject}: {data.Subject}
            </strong>
          </em>
        </small>
      )}
      <div className="activity-history-text" style={{ wordBreak: "break-all" }}>
        <SafeHtml html={data.Content} style={{ overflow: "auto" }} />
      </div>
      {data.Chat && (
        <button
          className="btn btn-intiza ps-0 mt-1"
          onClick={onReadMoreClicked}
        >
          {translate.ReadMore}
        </button>
      )}
    </div>
  );

  const dateNode = (
    <div className="dateTertiaryQ">
      {date.getHours() === 0 && date.getMinutes() === 0
        ? formatDateDigits(date)
        : formatDateTimeDigits(restTimezone(date))}
    </div>
  );

  const compactLine = (
    <>
      <strong>{creator}</strong>
      {" - "}
      {SanitizeUtils.htmlToPlainText(data.Content ?? "")}
    </>
  );

  return (
    <ActivityItemShell
      cardClassName="historyCard"
      iconNode={iconNode}
      headerNode={headerNode}
      dateNode={dateNode}
      content={contentNode}
      actions={actions}
      compactLine={compactLine}
    />
  );
};
